import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3883b7d3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3883b7d3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883b7d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3883b7d3')) {
      api.createRecord('3883b7d3', component.options)
    } else {
      api.reload('3883b7d3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3883b7d3&scoped=true", function () {
      api.rerender('3883b7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/tag/index.vue"
export default component.exports